import React, { useCallback, useMemo } from 'react'
import { useBreakpoints } from 'hooks'

const MultiSelect = ({ name, value, options, onChange }) => {
  const { md } = useBreakpoints()

  const handleChange = useCallback(
    selectedValue => {
      const parsedValue = value || []

      const updatedValues = parsedValue.includes(selectedValue)
        ? parsedValue.filter(v => v !== selectedValue)
        : [...parsedValue, selectedValue]
      onChange({
        target: {
          name,
          value: updatedValues,
        },
      })
    },
    [name, value, onChange]
  )

  const parsedOptions = useMemo(
    () =>
      options.map(option => ({
        ...option,
        selected: (value || []).includes(option.value),
      })),
    [value, options]
  )

  return (
    <div className="inset-0 z-20 bg-black w-full h-full flex flex-col text-white uppercase">
      <ul
        className="grow-1 overflow-y-scroll"
        style={{
          maxHeight: md ? '350px' : '50vh',
        }}
      >
        {parsedOptions.map(option => (
          <li
            key={option.value}
            className="px-5 font-medium cursor-pointer hover:bg-gray-800"
            onClick={() => handleChange(option.value)}
          >
            <div className="flex justify-between border-0 border-solid border-b border-white border-opacity-5 py-3.5">
              <div className="opacity-50">{option.label}</div>
              {option.selected && <div className="text-sm font-bold">✓</div>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default MultiSelect
